import { useContext, useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Card, CardContent, Grid } from "@mui/material";

import AppContext from "../../../context/AppContext";

import UnitMaterialsTable from "../UnitMaterialsTable";
import TotalsSummary from "../../../containers/Admin/Orders/TotalsSummary";

const defaultTaxRate = 0.085;

const useStyles = makeStyles({
  root: {},
});

const OrderDetail = ({ data }) => {
  const classes = useStyles();
  const { user } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [unitMaterials, setUnitMaterials] = useState([]);
  const [taxRate, setTaxRate] = useState(defaultTaxRate);

  useEffect(() => {
    if (!data) return;

    const { ORDER_ITEMS: orderItems } = data;
    const newUnitMaterials = orderItems ? JSON.parse(orderItems) : [];
    const newTaxRate =
      newUnitMaterials.length > 0 ? newUnitMaterials[0].TAX : defaultTaxRate;

    setUnitMaterials(newUnitMaterials);
    setTaxRate(newTaxRate);
  }, [data]);

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={4}>
                  {user?.USER_ROLE !== "FOREMAN" && (
                    <Grid item xs={12}>
                      <TotalsSummary
                        data={{ unitMaterials, taxRate }}
                        direction="horizontal"
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <UnitMaterialsTable
                      title="Unit materials"
                      loading={loading}
                      items={unitMaterials}
                      hiddenColumns={
                        user?.USER_ROLE === "FOREMAN"
                          ? [
                              "PROJECT_DESCRIPTION",
                              "JOB_DESC",
                              "UNIT_ID",
                              "PHASE_ID",
                              "NEW_ITEM_QTY",
                              "ITEM_COST",
                              "LINE_TOTAL",
                            ]
                          : [
                              "PROJECT_DESCRIPTION",
                              "JOB_DESC",
                              "UNIT_ID",
                              "PHASE_ID",
                              "NEW_ITEM_QTY",
                            ]
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default OrderDetail;
